import React, { useEffect, useState } from "react";
import Modal from "@zambezi/sdk/modal";

const IDLE_MINUTES_ALLOWED = 12;
const MODAL_COUNTDOWN_SECONDS = 120;

const IdleFormExpiryModal = ({ onSessionExpiry, shouldRender }) => {
  const [idleTimer, setIdleTimer] = useState(null);
  const [idleSeconds, setIdleSeconds] = useState(0);
  const [countdownTimer, setCountdownTimer] = useState(null);
  const [countdownSeconds, setCountdownSeconds] = useState(
    MODAL_COUNTDOWN_SECONDS
  );
  const [isModalOpen, setModalOpenState] = useState(false);

  const startCountdownTimer = () => {
    setCountdownTimer(
      setInterval(() => {
        setCountdownSeconds((countdownSeconds) => countdownSeconds - 1);
      }, 1000)
    );
  };

  const closeModalAndContinue = () => {
    setModalOpenState(false);
    clearInterval(countdownTimer);
    startIdleTimer();
    setCountdownSeconds(MODAL_COUNTDOWN_SECONDS);
  };

  const startIdleTimer = () => {
    setIdleTimer(
      setInterval(() => {
        setIdleSeconds((idleSeconds) => idleSeconds + 1);
      }, 1000)
    );
  };

  const restartIdleTimer = () => {
    setIdleSeconds(0);
  };

  const detectMouseInteraction = (e) => {
    let el = e.target;
    if (
      (el.nodeName.toLowerCase() === "button" &&
        el.dataset.buttonType &&
        el.dataset.buttonType.match(/next|back/g)) ||
      (el.nodeName.toLowerCase() === "input" && el.type === "checkbox") ||
      (el.className &&
        el.className
          .toString()
          .match(/zb-checkbox|zb-radio-button|zb-month-calendar-month/g))
    ) {
      restartIdleTimer();
    }
  };

  const detectKeyboardEntry = (e) => {
    let el = e.target;
    if (el.nodeName.toLowerCase() === "input" && el.type === "text") {
      restartIdleTimer();
    }
  };

  // Start the idle timer on first page load
  useEffect(() => {
    startIdleTimer();
    document.addEventListener("click", detectMouseInteraction, false);
    document.addEventListener("keydown", detectKeyboardEntry, false);
  }, []);

  // Monitor the idle seconds as long as the user is idle (maximum of 13 minutes)
  useEffect(() => {
    const idleSecondsAllowed = IDLE_MINUTES_ALLOWED * 60;
    if (idleSeconds === idleSecondsAllowed) {
      clearInterval(idleTimer);
      setModalOpenState(true);
      setIdleSeconds(0);
    }
  }, [idleSeconds]);

  // Monitor the number of seconds as the modal counts down from 120 seconds to 0
  useEffect(() => {
    if (countdownSeconds === 0) {
      clearInterval(countdownTimer);
      setModalOpenState(false);
      onSessionExpiry();
    }
  }, [countdownSeconds]);

  useEffect(() => {
    return () => {
      clearInterval(idleTimer);
      clearInterval(countdownTimer);
    };
  }, [shouldRender]);

  return (
    shouldRender && (
      <Modal
        title="Are you still there?"
        confirm="I'm still here"
        open={isModalOpen}
        onOpen={startCountdownTimer}
        onConfirm={closeModalAndContinue}
        isClosable={false}
        data-testid="idleFormModal"
      >
        <p>
          <strong>
            You have only 2 minutes remaining until we automatically log you
            out.
          </strong>
        </p>
        <p>
          You'll need to complete any requests within 56 minutes. If you're
          inactive for any longer than 14 minutes, we'll log you out for your
          own security.
        </p>
        <p>
          Be sure to tap the page or click your mouse every now and then to keep
          your page active, that way you won't loose any progress you've made.
        </p>
      </Modal>
    )
  );
};

export default IdleFormExpiryModal;
